import {baseUri} from '@jetbrains/teamcity-ui'

const prodPath = 'js/ring/'

if (__webpack_public_path__ === prodPath) {
  __webpack_public_path__ = `${baseUri}/${prodPath}`
}
